
export default [
  {
    path: '/admin/dealer-grades',
    name: 'dealer-grade',
    meta: { requiresAuth: true },
    component: () => import('@/pages/customer/dealer-grade')
  }
]
